import React, { useEffect, useState } from 'react';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboResponsablesArea from './combo';

export const ComboResponsablesAreaContainer = (props: any) => {
  
  const api = new UsuariosAdapter();
  const { exceptionError, resultError } = useNotifications();
  let [responsables, setResponsables] = useState<any>(undefined)
  let result: any;
  let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
  
  // useEffect(()=>{
  //   getResponsables();
  // },[])

  useEffect(()=>{
    if(!props.disabled){
      if(props.idDN && props.codArea){
					getResponsables(props.idDN,props.codArea);
					setSelectedOptions([...[]])
      }else{
        props.dependency ? setResponsables([...[]]) : getAllResponsables()
      }
    }
	},[props.idDN, props.codArea])
	
	useEffect(()=>{setSelectedOptions(props.selectedOptions)},[props.selectedOptions])


	const getAllResponsables = async() =>{
    try {
      result = await api.ListarTodosResponsablesArea();
      if(result.data && result.data!=="")
			{
        setResponsables([...result.data] || []);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  const getResponsables = async(idDN:string, codArea:string) =>{
    try {
      result = await api.ListarResponsablesArea(idDN, codArea);
      if(result.data && result.data!=="")
			{
        setResponsables([...result.data] || []);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }


  return <ComboResponsablesArea {...{...props,...{selectedOptions:selectedOptions}}} options={responsables}/>
};

export default ComboResponsablesAreaContainer;